import { CasesResultCard } from '../../CasesSearch/CasesResultCard';
import { AccordionResultsSection } from '../../shared';
import { useJudgeAssignedCases } from '../api';

interface JudgeCasesAssignedProps {
  judgeId: number;
  judgeName: string;
}

export const JudgeCasesAssigned = ({
  judgeId,
  judgeName,
}: JudgeCasesAssignedProps) => {
  const {
    data: casesData,
    isLoading,
    isError,
    error,
    isTokenLoading,
  } = useJudgeAssignedCases(judgeId);
  const isLoadingOrToken = isLoading || isTokenLoading;
  const allCases = casesData?.results ?? [];
  const totalCount = casesData?.count ?? 0;

  return (
    <AccordionResultsSection
      title={`Cases Assigned to ${judgeName} (${totalCount})`}
      isLoading={isLoadingOrToken}
      isError={isError}
      error={error}
      errorLabel="Error loading assigned cases"
      results={allCases}
      emptyMessage={`No assigned cases found for ${judgeName}.`}
      renderCard={(docketItem) => <CasesResultCard docketItem={docketItem} />}
      getKey={(docketItem, index) => docketItem.docket_id ?? index}
    />
  );
};
